export enum FetchPaymentOrderActionTypes {
  FETCHING_ORDER = 'payment/FETCHING_ORDER',
  ORDER_RECEIVED = 'payment/ORDER_RECEIVED',
}
